<template >
  <Modal
    v-model="val"
    :width="600"
    style="overflow: hidden;"
    @on-cancel="closeModal"
    @close="hreflocal1"
    @before-close="hreflocal"
  >
    <div v-if="val">
      <h2  v-text="okMsg.title"/>
      <div class="fz-tiny" > {{okMsg.msgcontent}}</div>
    </div>
    <div slot="footer" />
  </Modal>
</template>
<script>
import { Modal } from "iview";
import Cookies from 'js-cookie';

export default {
  components: { Modal },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    okMsg:{
      type:Object,
      default:null
    },
    title: {
        type: String,
        default: null
      },
      msgcontent: {
        type: String,
        default: null
      },
    closeModal: {
      type: Function,
      default: () => {        
        const refid = Cookies.get('refid');        
        if (refid=='4v6b34jk8b'&& (Date.now().valueOf()>=Date.parse("2020/9/1").valueOf())&& (Date.now().valueOf()<Date.parse("2020/12/1").valueOf())){
          window.open("http://www.allstate.com.tw:8888/SCR/login.aspx?id=91841d39-b1b3-488c-9785-6ede392af191", "_blank");
        }
        else if (refid=='a26gzxnke5' && (Date.now().valueOf()>=Date.parse("2020/8/1").valueOf())&& (Date.now().valueOf()<Date.parse("2020/10/1").valueOf()))
        {
        window.open("http://www.allstate.com.tw:8888/SCR/login.aspx?id=cc91e62e-07d5-4057-9c8c-12ab08faa679", "_blank");
        }
        else{          
        }
        window.location.href = "/";
      }
    }
  },
  data() {    
    return;
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
  }
};
</script>